/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Title_ColInputs */

const en_admin_tickets_title_col = /** @type {(inputs: Admin_Tickets_Title_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject`)
};

const zh_admin_tickets_title_col = /** @type {(inputs: Admin_Tickets_Title_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题`)
};

/**
* | output |
* | --- |
* | "Subject" |
*
* @param {Admin_Tickets_Title_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_title_col = /** @type {((inputs?: Admin_Tickets_Title_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Title_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_title_col(inputs)
	return zh_admin_tickets_title_col(inputs)
});
export { admin_tickets_title_col as "admin.tickets.title_col" }